import React from 'react'
import { useTranslation } from 'react-i18next'
import NaukasanaImg from '../../../../../assets/images/yoga/Naukasana.png'
import SubCard from '../../../../../comon/SubCard'
import Header from '../../subcategory/Header'

const HeadAche = () => {
    const {t} = useTranslation();
    return (
        <>
        <Header headtitle={t("yoga.headacheyoga")} />
        <SubCard fitImg={NaukasanaImg} title={t("Naukasana.title")} context={false} workoutLink='/naukasana' />
        </>
      )
    }

export default HeadAche
